// extracted by mini-css-extract-plugin
export default {"tabnav":"TabsBar_tabnav__iUWFM","tab":"TabsBar_tab__beAkS","hide":"TabsBar_hide__TgtmU"};